// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1xn-j","head":"Table_head__Cd30_","col":"Table_col__1Fw6z"};